import { getMeta } from '@helpcenter/meta';
import type { RouterContext } from 'react-resource-router';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import { createHelpCenterAri } from '../../../../src/utils/ari-parser';
import type { srcRovoServiceAgentSettingsQuery } from './__generated__/srcRovoServiceAgentSettingsQuery.graphql';
import srcRovoServiceAgentSettingsQueryArtifact from './__generated__/srcRovoServiceAgentSettingsQuery.graphql';

export const HelpCenterRovoServiceAgentResource =
	createRelayResource<srcRovoServiceAgentSettingsQuery>({
		type: 'HELP_ROVO_SERVICE_AGENT_PAGE',
		getQuery: (
			{ match }: RouterContext,
			{ cloudId, helpCenterAri }: { cloudId: string; helpCenterAri: string },
		) => {
			const activationId = getMeta('activation-id') || '';
			const helpCenterId = match.params.helpcenterId || '';
			const computedHelpCenterAri = createHelpCenterAri(activationId, helpCenterId);
			// Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
			const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
			return {
				parameters: srcRovoServiceAgentSettingsQueryArtifact,
				variables: {
					cloudId,
					helpCenterAri: finalHelpCenterAri,
				},
				options: {
					fetchPolicy: 'store-or-network',
				},
			};
		},
	});
